import { LIVE_CLASS_URL, LIVE_CLASS } from "../../utils/url-builder";
import BaseService from "../services/base.service";
import io from "socket.io-client";
import { HTTP_CODES } from "../constants/httpCodes.constants";

export const LIVE_CLASS_EVENT = {
  JOIN_ROOM: "JOIN_ROOM",
  ROOM_UPDATE: "ROOM_UPDATE",
  LEFT_ROOM: "LEFT_ROOM",
  SEND_ALL: "SEND_ALL",
};

export const LIVE_CLASS_TYPE = {
  AUTHENTICATION_ERROR: "AUTHENTICATION_ERROR",
  AUTHENTICATION_SUCCESS: "AUTHENTICATION_SUCCESS",
  ROOM_UPDATE: "ROOM_UPDATE",
  ROOM_JOIN_SUCCESS: "ROOM_JOIN_SUCCESS",
};

export const CHANNEL_NAME = {
  USER_JOINED: "USER_JOINED",
  ROOM_UPDATE: "ROOM_UPDATE",
  MOVE_MOUSE: "MOVE_MOUSE",
};

export const CONFERENCE_TYPE = {
  VIRTUAL_TUTORING: "VIRTUAL_TUTORING",
  AUDIO_TUTORING: "AUDIO_TUTORING",
};

export const OUTPUT_CHANNEL = {
  CHANGE_TAB_TO: "CHANGE_TAB_TO",
  TOGGLE_MICROPHONE_TO: "TOGGLE_MICROPHONE_TO",
  TOGGLE_WEBCAM_TO: "TOGGLE_WEBCAM_TO",
  TOGGLE_SCREEN_SHARE_TO: "TOGGLE_SCREEN_SHARE_TO",
  TOGGLE_USER_MICROPHONE_TO: "TOGGLE_USER_MICROPHONE_TO",
  LEAVE_SESSION: "LEAVE_SESSION",
  RAISE_HAND: "RAISE_HAND",
  UN_RAISE_HAND: "UN_RAISE_HAND",
  UPDATE_CURSOR: "UPDATE_CURSOR"
};

export const OUTPUT_MESSAGE = {
  CHAT_TAB: "CHAT_TAB",
  USERS_TAB: "USERS_TAB",
  VIDEO_TAB: "VIDEO_TAB",
  ENABLE_MICROPHONE: "ENABLE_MICROPHONE",
  DISABLE_MICROPHONE: "DISABLE_MICROPHONE",
  ENABLE_SCREEN_SHARE: "ENABLE_SCREEN_SHARE",
  DISABLE_SCREEN_SHARE: "DISABLE_SCREEN_SHARE",
  ENABLE_WEBCAM: "ENABLE_WEBCAM",
  DISABLE_WEBCAM: "DISABLE_WEBCAM",
  LEAVE_SESSION: "LEAVE_SESSION",
};

export const INPUT_CHANNEL = {
  MESSAGE: "message",
  UPDATE_ROOM_TO: "UPDATE_ROOM_TO",
  SPEAKING_STATUS_TO: "SPEAKING_STATUS_TO",
  USER_JOINING_MEETING: "USER_JOINING_MEETING",
  USER_MICROPHONE_CONNECTED: "USER_MICROPHONE_CONNECTED",
  CONNECTION_FAILURE: "CONNECTION_FAILURE",
  UPDATE_CURSOR: "UPDATE_CURSOR",
  USER_LEFT: "USER_LEFT"
};

export const INPUT_MESSAGE = {
  CONFERENCE_READY: "CONFERENCE_READY",
  SWITCHED_TO_CHAT_TAB: "SWITCHED_TO_CHAT_TAB",
  SWITCHED_TO_VIDEO_TAB: "SWITCHED_TO_VIDEO_TAB",
  SWITCHED_TO_USERS_TAB: "SWITCHED_TO_USERS_TAB",
  MICROPHONE_ENABLED: "MICROPHONE_ENABLED",
  MICROPHONE_DISABLED: "MICROPHONE_DISABLED",
  WEBCAM_ENABLED: "WEBCAM_ENABLED",
  WEBCAM_DISABLED: "WEBCAM_DISABLED",
  SCREEN_SHARE_ENABLED: "SCREEN_SHARE_ENABLED",
  SCREEN_SHARE_DISABLED: "SCREEN_SHARE_DISABLED",
  GOT_NEW_MESSAGE: "GOT_NEW_MESSAGE",
  LEAVE_SESSION: "LEAVE_SESSION",
  HAND_RAISED: "HAND_RAISED",
  HAND_UN_RAISED: "HAND_UN_RAISED",
};
class LiveClassService extends BaseService {
  constructor() {
    super(LIVE_CLASS_URL);
    this.socket = null;
    this.isConnected = false;
  }

  connectSocket() {
    const url = LIVE_CLASS.socket();
    if (this.socket !== null) {
      return;
    }
    this.socket = io(url, { path: "/live-class-server-socket" });
    this.socket.on("connect", () => {
      this.isConnected = true;
    });
    this.socket.on("disconnect", () => {
      this.isConnected = false;
    });
  }

  getID() {
    if (!this.socket) {
      return "";
    }
    return this.socket.id;
  }

  disconnectSocket() {
    if (this.socket === null) {
      return;
    }
    this.socket.disconnect();
    this.socket = null;
  }

  onConnected({ callback }) {
    setTimeout(() => {
      if (this.isConnected === true) {
        return callback();
      }
      this.socket.on("connect", () => {
        callback();
      });
    }, 2000);
  }

  onDisconnected({ callback }) {
    setTimeout(() => {
      if (this.isConnected === true) {
        return callback();
      }
      this.socket.on("disconnect", () => {
        callback();
      });
    }, 2000);
  }

  ensureConnection() {
    if (this.socket === null) {
      this.connectSocket();
    }
  }

  // registerSuccess({ type, callback }) {
  //   // this.ensureConnection();
  //   const token = localStorage.getItem("usertoken");
  //   this.socket.on(token, (res) => {
  //     if (res === null) { return };
  //     const { value } = res;
  //     if (value.type === type) {
  //       callback(value.message)
  //     }
  //   })
  // }

  registerError({ callback }) {
    // this.ensureConnection();
    const token = localStorage.getItem("usertoken");
    this.socket.on(token, (res) => {
      if (res === null) {
        return;
      }
      const { statusCode, value } = res;
      if (statusCode !== HTTP_CODES.SUCCESS) {
        callback(value.message);
      }
    });
  }

  registerChannel({ channelName, callback }) {
    // this.ensureConnection();
    if (this.socket === null) {
      return;
    }
    this.socket.on(channelName, (data) => {
      callback(data.value.message);
    });
  }

  send({ eventName, message }) {
    if (this.socket === null) {
      return;
    }
    // if (this.socket === null) {
    //   this.connectSocket();
    // }
    const flowID = JSON.parse(sessionStorage.getItem("boardinfo")).flow_id;
    const msg = JSON.stringify({ ...message, flowID });
    this.socket.emit(eventName, msg);
  }

  sendToAll({ eventName, message }) {
    // this.ensureConnection();
    this.socket.emit(eventName, message);
  }

  registerGlobal({ channelName, callback }) {
    this.ensureConnection();
    this.socket.on(channelName, (msg) => callback(msg));
  }

  sendGlobal({ eventName, message }) {
    this.ensureConnection();
    this.socket.emit(eventName, message);
  }

  getSocketID() {
    return this.socket.id;
  }
}

const liveClassService = new LiveClassService();

export default liveClassService;
